<button
  mat-icon-button
  [matTooltip]="'Refresh Widget'"
  [intercomTarget]="'toolbar-context-menu-refresh'"
  (click)="refreshClick.emit()"
>
  <fa-icon class="fs-08" [icon]="['fal', 'sync']"></fa-icon>
</button>
